export const SYNC_CONTENT_TYPES = [
  {
    label: 'application/json',
    value: 'application/json'
  },
  {
    label: 'application/ld+json',
    value: 'application/ld+json'
  },
  {
    label: 'application/xml',
    value: 'application/xml'
  },
  {
    label: 'text/javascript',
    value: 'text/javascript'
  },
  {
    label: 'text/plain',
    value: 'text/plain'
  }
];
